import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2364">
      <div className="dark" data-id="element-2365">
        <Hero data-id="element-2366" />
      </div>
      <WhyUs data-id="element-2367" />
      <ByTheNumbers data-id="element-2368" />
      <Services data-id="element-2369" />
      <HowItWorks data-id="element-2370" />
      <FAQ data-id="element-2371" />
      <Reviews data-id="element-2372" />
      <CtaBanner data-id="element-2373" />
    </main>;
}